var _path, _path2, _path3, _path4, _path5, _rect, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3649 22.2385C13.0763 22.2385 12.884 22.1423 12.6916 21.9499L9.99851 19.2568C9.61378 18.8721 9.61378 18.295 9.99851 17.9103C10.3832 17.5256 10.9603 17.5256 11.3451 17.9103L13.3649 19.9301L18.6549 14.6401C19.0396 14.2554 19.6167 14.2554 20.0014 14.6401C20.3862 15.0248 20.3862 15.6019 20.0014 15.9867L14.0382 21.9499C13.8458 22.1423 13.6534 22.2385 13.3649 22.2385Z",
    fill: "#41AA46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6181 4.7334H22.6944V6.56086V6.65704H24.6181V9.5425H5.38165V6.65704H7.30529V6.56086V4.7334H5.38165C4.32365 4.7334 3.45801 5.59904 3.45801 6.65704V25.8935C3.45801 26.9515 4.32365 27.8171 5.38165 27.8171H24.6181C25.6761 27.8171 26.5417 26.9515 26.5417 25.8935V6.65704C26.5417 5.59904 25.6761 4.7334 24.6181 4.7334ZM24.6181 25.8935H5.38165V10.5043H24.6181V25.8935Z",
    fill: "#41AA46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8472 6.65704V6.56086V4.7334H11.1526V6.56086V6.65704H18.8472Z",
    fill: "#41AA46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22891 2.80981C8.65182 2.80981 8.26709 3.19454 8.26709 3.77164V6.6571C8.26709 7.23419 8.65182 7.61892 9.22891 7.61892C9.806 7.61892 10.1907 7.23419 10.1907 6.6571V3.77164C10.1907 3.19454 9.806 2.80981 9.22891 2.80981Z",
    fill: "#41AA46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7709 2.80981C20.1938 2.80981 19.8091 3.19454 19.8091 3.77164V6.6571C19.8091 7.23419 20.1938 7.61892 20.7709 7.61892C21.348 7.61892 21.7327 7.23419 21.7327 6.6571V3.77164C21.7327 3.19454 21.348 2.80981 20.7709 2.80981Z",
    fill: "#41AA46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.41992,
    y: 6.65698,
    width: 20.1982,
    height: 2.88546,
    fill: "#41AA46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22915 2.3289C8.43236 2.3289 7.78642 2.97484 7.78642 3.77164V6.6571C7.78642 7.4539 8.43236 8.09983 9.22915 8.09983C10.026 8.09983 10.6719 7.4539 10.6719 6.6571V3.77164C10.6719 2.97484 10.026 2.3289 9.22915 2.3289ZM20.771 2.3289C19.9742 2.3289 19.3283 2.97484 19.3283 3.77164V6.6571C19.3283 7.4539 19.9742 8.09983 20.771 8.09983C21.5678 8.09983 22.2137 7.4539 22.2137 6.6571V3.77164C22.2137 2.97484 21.5678 2.3289 20.771 2.3289Z",
    fill: "#41AA46",
    stroke: "white",
    strokeWidth: 0.961821
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooked);
export default __webpack_public_path__ + "static/media/booked.e7163fc3f5777f25ea54ee236a128ee1.svg";
export { ForwardRef as ReactComponent };